// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hj58","content":"styles_content__3WAnL"};